import React, { useContext, useEffect, useState } from 'react'
import { LoadingFull, LoadingOverlay } from '../../loading';
import axios from 'axios';
import { UserContext } from '../../../App';
import { FiEdit } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useLocation } from 'react-router-dom';
import Modal from './modal';

export const Payout = ({returnUrl, setError}) => {

  const [load, setLoad] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const { auth, user, setUser } = useContext(UserContext)
  const [name, setName] = useState(user.first_name + " " + user.last_name)
  const [iban, setIban] = useState('')
  const location = useLocation()
  const [errorMessage, setErrorMessage] = useState('')
  const token = localStorage.getItem('token')
  
  function accountLink() {
    setLoad(true)
    axios({
        method: 'post',
        url: '/api/accountLink',
        data: {
            'stripeId': user.stripeId,
            'returnUrl': returnUrl
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
      window.location.href = response.data.url
    })
    .catch(error => {
      console.log(error);
    });
  }
  
  function addBank() {
    if (name !== '') {
      if (/^DK\d{16}$/.test(iban)) {
        setLoad(true)
        axios({
            method: 'post',
            url: '/api/createBankToken',
            data: {
                'stripeId': user.stripeId,
                'iban': iban,
                'account_holder_name': name
            },
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(response => {
          setLoad(false)
          setUser(prev => ({
            ...prev,
            stripe: response.data.acc
          }))
          setShowModal(false)
        })
        .catch(error => {
          setLoad(false)
          setErrorMessage('Indtast et gyldigt IBAN-nummer')
          console.log(error);
        });
      } else {
        setErrorMessage('Indtast et gyldigt IBAN-nummer')
      }
    } else {
      setErrorMessage('Indtast kontoholderens navn')
    }
  }

  const ibanChange = (e) => {
    setErrorMessage('')
    let val = e.target.value.toUpperCase().replace(/\s/g, '');

    // Sørg for at "DK" altid er i starten
    if (!val.startsWith('DK')) {
      val = 'DK' + val.replace(/[^0-9]/g, '');
    }

    // Fjern alle ikke-tal fra resten af inputtet (efter DK)
    let digits = val.slice(2).replace(/\D/g, '');

    // Begræns til maks 16 cifre efter DK
    digits = digits.slice(0, 16);

    // Sæt det samlede IBAN
    setIban('DK' + digits);
  };

  useEffect(() => {
    if (!showModal) {
      setIban('')
    }
    if (setError) {
      setError('')
    }
  }, [showModal])

  return (
    <>
      <div className={"relative bankInfo px-5 md:px-10 py-5 cursor-pointer flex justify-between items-center text-sm w-full" + (location.pathname.includes("dashboard") ? " shadow-lg hover:bg-gray-50" : " ring-1 ring-neutral-300 hover:bg-gray-100")} onClick={() => setShowModal(true)}>
        {(load) ?
          <LoadingOverlay />
        :
          ""
        }
        {(typeof user !== 'undefined') ?
          (Object.keys(user.stripe.external_accounts).length !== 0) ?
            <>
                <div className="addressDetails flex flex-col gap-1">
                    <h2 className="font-medium">{user.stripe.external_accounts.data[0].account_holder_name}</h2>
                    <div>
                        <p className="text-sm">{user.stripe.external_accounts.data[0].bank_name}</p>
                        <p className="text-sm">{user.stripe.external_accounts.data[0].country}****{user.stripe.external_accounts.data[0].last4}</p>
                    </div>
                </div>
                <FiEdit className="text-base md:text-xl" />
            </>
          :
            <>
              <div className="addressDetails">
                <p>Tilføj udbetalingskonto</p>
              </div>
              <AiOutlinePlus className="text-base md:text-xl" />
            </>
        :
          <LoadingFull />
        }
      </div>
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        {(load) ?
          <LoadingOverlay />
        :
          ""
        }
        <div className="space-y-10">
          <h2 className="font-semibold text-base md:text-lg">Indtast kontooplysninger</h2>
          {(errorMessage !== '') ?
              <div className="text-center text-sm w-full py-4 px-2 bg-red-200">
                  <p>{errorMessage}</p>
              </div>
          :
              ""
          }
          <div className="space-y-4">
            <div>
                <label for="name" className="block mb-2 text-sm font-medium text-gray-900">Kontoholderens navn</label>
                <input type="text" name="name" className="bg-transparent flex-[1] w-full border-b border-gray-300 block focus:outline-none p-2.5 text-sm text-gray-900" value={name} onChange={(e) => setName(e.target.value) & setErrorMessage('')} required />
            </div>
            <div>
                <label for="iban" className="block mb-2 text-sm font-medium text-gray-900">IBAN</label>
                <div className="flex gap-2 items-center relative">
                    <input type="text" id="iban" inputMode="numeric" onKeyDown={(e) => e.key === 'Enter' ? addBank() : ""} placeholder="DKXXXXXXXXXXXXXXXX" style={{ textTransform: 'uppercase' }} maxLength={18} className="bg-gray-50 border border-gray-300 text-gray-900 block w-full p-2.5 outline-none text-sm sm:text-base" value={iban} onChange={ibanChange} required />
                </div>
            </div>
          </div>
            <div className="button relative text-center bg-gradient-to-r from-emerald-500 to-emerald-800 transition-[] bg-size-200 bg-pos-0 hover:bg-pos-100 p-4 text-white w-full text-nowrap cursor-pointer" onClick={addBank}>
              Tilføj udbetalingskonto
            </div>
        </div>
      </Modal>
    </>
  )
}